import { useThumbnailForTs, UseThumbnailOptions } from '../hooks/useThumbnailForTs';
import { generateFallbackThumbnailDisplayInfo } from '../utils';
import { LoadingThumbnail } from './LoadingThumbnail';
import { MissingThumbnail } from './MissingThumbnail';
import { PreloadedThumbnail } from './PreloadedThumbnail';

interface Props {
  stationId: string;
  ts: number;
  animated?: boolean;
  theme?: 'dark' | 'light';
  useThumbnailOptions?: UseThumbnailOptions;
  targetHeight?: number;
}

export function TsThumbnail({
  stationId,
  ts,
  animated,
  theme = 'light',
  useThumbnailOptions,
  targetHeight,
}: Props) {
  const thumb = useThumbnailForTs(stationId, ts, useThumbnailOptions);

  if (thumb.isLoading) {
    return (
      <LoadingThumbnail
        metadata={generateFallbackThumbnailDisplayInfo()}
        theme={theme}
        targetHeight={targetHeight}
      />
    );
  }

  if (!thumb.info) {
    return (
      <MissingThumbnail
        metadata={generateFallbackThumbnailDisplayInfo()}
        theme={theme}
        targetHeight={targetHeight}
      />
    );
  }

  return (
    <PreloadedThumbnail
      {...thumb.info}
      animated={animated}
      theme={theme}
      targetHeight={targetHeight}
    />
  );
}
